import { render, staticRenderFns } from "./VideoTooltip.vue?vue&type=template&id=7135a348&scoped=true&"
import script from "./VideoTooltip.vue?vue&type=script&lang=js&"
export * from "./VideoTooltip.vue?vue&type=script&lang=js&"
import style0 from "./VideoTooltip.vue?vue&type=style&index=0&id=7135a348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7135a348",
  null
  
)

export default component.exports